export default {
  seeMoreText: 'Vedi di più',
};
